import React, { Component } from 'react'
import DropZone from './DropZone'
import CropImage from './CropImage'

class DropAndCrop extends Component {
    
    static defaultProps = {
        img: '',
        onDrop: () => console.log('dropped'),
        onCrop: () => console.log('cropped'),
        cropProps: {
            base64: true,
            cropOptions: {}
        },
        dropProps: {}
    }

    constructor(props) {
        super(props)
    
        this.state = {
            image: props.img
        }
    }

    render() {
        const { image } = this.state;

        return (
            <div className="drop-and-crop">
                {
                    image ? this.renderCrop() : this.renderDrop()
                }
            </div>
        )
    }

    renderDrop = () => {
        const { dropProps } = this.props;

        console.log(dropProps);
        return (
            <DropZone onChange={this.handleDrop} {...dropProps} />
        )
    }

    renderCrop = () => {
        const { image } = this.state;
        const { cropProps } = this.props;

        return (
            <CropImage image={image} onChange={this.handleCrop} {...cropProps} />
        )
    }

    /**
     * Handlers
     */

    handleDrop = files => {
        const { onDrop } = this.props;
        const image = files ? files[0] : '';
        this.setState({ image });
        onDrop(image);
    }

    handleCrop = image => {
        const { onCrop } = this.props;
        this.setState({ image });
        onCrop(image);
    }
}

export default DropAndCrop